import { Tabs } from "@mui/material";
import { ReactNode } from "react";
import colors from '../utils/index.module.scss';

interface Props {
    children: ReactNode
    value: number
    negativeMargin: number
    handleChange: (event: React.SyntheticEvent, newValue: number) => void
}

export function HorizontalTabPrimaryComponent(props: Props) {
    const { children } = props;
    const { value } = props;
    const { negativeMargin } = props;
    const { handleChange } = props;

    return (
        <Tabs
            variant="scrollable"
            sx={{
                '& .MuiTabs-indicator': {
                    display: 'none',
                },
                '& .MuiTabs-scroller': {
                    minHeight: '10px !important',
                    height: '44px',
                },
                "& .MuiButtonBase-root": {
                    background: colors.white,
                    borderRadius: '8px 8px 0 0',
                    padding: '12px 16px 12px 16px',
                    minHeight: '10px !important',
                    height: '44px !important',
                    minWidth: '10px !important',
                    color: colors.neutral400,
                    fontFamily: 'Figtree',
                    fontWeight: 500,
                    fontSize: '16px !important',
                    lineHeight: '20px !important',
                    textTransform: 'none',
                    transition: '.2s all ease',
                    width: 'auto !important',
                    gap: '8px',
                    '&.Mui-selected': {
                        background: colors.primary50,
                        color: colors.primary900,
                    },
                    '&:hover': {
                        background: colors.white,
                        color: colors.primary500
                    },
                    '&:disabled': {
                        color: colors.neutral200
                    }
                },
                '& .MuiTabs-flexContainer': {
                    display: 'flex',
                    justifyContent: 'flex-start',
                    height: '44px',
                    backgroundColor: colors.white
                },
                '& .MuiTabs-root': {
                    minHeight: '10px !important',
                    height: '44px',
                    width: '100%'
                },
                minHeight: '10px !important',
                height: '44px',
                width: 'calc(100% + 2 * ' + negativeMargin + 'px)',
                margin: ('0 -' + negativeMargin + 'px'),
                padding: '0 12px',
                borderBottom: '1px solid ' + colors.primary50
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
        >
            {children}
        </Tabs>
    )
}
